'use strict'
const _ = require('lodash')

function handleControllerSettingsUpdate({appDefinitionId, compId, getAllApps, updates, controllerUpdateAPI}) {
    const app = _.find(getAllApps(), ['appDefId', appDefinitionId])
    const controllersOnConfigUpdate = _.get(app, 'controllersOnConfigUpdate')
    if (controllersOnConfigUpdate) {
        const controller = _.find(controllersOnConfigUpdate, {compId})
        if (controller) {
            try {
                _.invoke(controller, controllerUpdateAPI, updates)
            } catch (e) {
                // do nothing as this will only occur on page navigation and not when settings have been updated
                return
            }
        }
    }
}

function handleControllerConfigUpdate(messageData, {getAllApps}) {
    const {appDefinitionId, compId, configUpdates} = messageData
    handleControllerSettingsUpdate({appDefinitionId, compId, getAllApps, updates: configUpdates, controllerUpdateAPI: 'onConfigUpdate'})
}

function handleControllerAppSettingsUpdate(messageData, {getAllApps}) {
    const {appDefinitionId, compId, updates} = messageData
    handleControllerSettingsUpdate({appDefinitionId, compId, getAllApps, updates, controllerUpdateAPI: 'onAppSettingsUpdate'})
}

module.exports = {
    handleControllerConfigUpdate,
    handleControllerAppSettingsUpdate
}

